export default "__VITE_ASSET__Cos8ciO7__"